import React from "react";

import styled from "styled-components/macro";

import { useBackgroundColor } from "Signups/stateHooks";
import { getBackgroundString } from "Signups/utils/getBackgroundString";
import { motion } from "framer-motion";

import { BackgroundEditor } from "./BackgroundEditor";
import Description from "./Description";
import ImageVideoSection from "./ImageVideoSection";
import { StaggerIn } from "./StaggerIn";

// import PropTypes from 'prop-types'

export function CustomizeSignupOptions() {
  const { backgroundColorScheme, backgroundColor, colorVariant } =
    useBackgroundColor();
  const gradientString = getBackgroundString(backgroundColorScheme);
  const [showColorPicker, setShowColorPicker] = React.useState(false);

  return (
    <Container data-customize-bg-color={backgroundColor}>
      <SignupDesignOptionsWrapper
        $lightMode={colorVariant === "light"}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, background: gradientString }}
      >
        <StaggerIn gap={24} initialDelay={0.2} stepDuration={0.4}>
          <BackgroundEditor
            showColorPicker={showColorPicker}
            setShowColorPicker={setShowColorPicker}
          />
          <ImageVideoSection showingColorPicker={showColorPicker} />
          <Description lightMode={colorVariant === "light"} />
        </StaggerIn>
      </SignupDesignOptionsWrapper>
    </Container>
  );
}

// CustomizeSignupOptions.propTypes = {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin: 0.75rem;
  max-width: 1100px;
  font-weight: 400;
  max-width: 600px;
`;

const SignupDesignOptionsWrapper = styled(motion.div)`
  position: relative;
  background: linear-gradient(135deg, #ff8a65, #ff3d00);
  padding: 8px;
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 6px;
  border-radius: 12px;
  color: ${({ $lightMode }) => ($lightMode ? "#383838" : "#eceff0")};
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: hidden;
`;